import { connect } from 'react-redux'
import { compose, withProps } from 'recompose'
import { openLoans, closeLoans } from 'src/actions/homeowner'
import {
  selectLoanFocus,
  selectDisableAnimateLoanFocus
} from 'src/store/selectors/home/homeowner'
import withDelayedRenderValue from 'src/composables/withDelayedRenderValue'

const HomeownerDashboardContainer = compose(
  connect(
    state => ({
      loanFocus: selectLoanFocus(state),
      disableAnimate: selectDisableAnimateLoanFocus(state)
    }),
    dispatch => ({
      openLoans: () => dispatch(openLoans()),
      closeLoans: () => dispatch(closeLoans())
    })
  ),
  withProps(
    // Guard open and close to only fire when needed
    // Prevents event bubbling from causing open followed by immediate close
    ({ loanFocus, openLoans, closeLoans }) => ({
      openLoans: () => !loanFocus && openLoans(),
      closeLoans: () => loanFocus && closeLoans(),
      render: true
    })
  ),
  withDelayedRenderValue({
    fromProp: 'render',
    toProp: 'delayedRender',
    initialValue: false,
    delay: 1
  })
)

export default HomeownerDashboardContainer
